import { getUA, isAndroid, isIPad13, isMobile } from 'react-device-detect'

const MATHFLAT_ANDROID_APP_USER_AGENT = 'mathflat-android-app'
const MATHFLAT_IPAD_APP_USER_AGENT = 'mathflat-ipad-app'

export type AppDeviceInfo = {
  device: string
  version: string
}

export const VersionCode_BeforeExportFix = 110021 // mergePdf 추가 이전 버전

export default class WebviewService {
  static isMobile = isMobile
  static isWebPC = !isMobile
  static device?: string = undefined
  static version?: number = undefined

  // 안드로이드 크롬 브라우저
  static isWebAndroid = isMobile && isAndroid && getUA.indexOf(MATHFLAT_ANDROID_APP_USER_AGENT) < 0
  // 안드로이드 매쓰플랫 앱
  static isAppAndroid = isMobile && isAndroid && getUA.indexOf(MATHFLAT_ANDROID_APP_USER_AGENT) > -1
  // 아이패드 브라우저
  static isWebIpad = isIPad13 && getUA.indexOf(MATHFLAT_IPAD_APP_USER_AGENT) < 0
  // 아이패드 매쓰플랫 앱
  static isAppIpad = isIPad13 && getUA.indexOf(MATHFLAT_IPAD_APP_USER_AGENT) > -1
  // 기기가 아이패드 태블릿
  static isIpad = this.isWebIpad || this.isAppIpad
  // 기기가 안드로이드 태블릿
  static isAndroid = this.isWebAndroid || this.isAppAndroid
}

globalThis.webviewService = WebviewService
